/*
 * Class to show loading state
 *
 * Version: 1.0
 *
 * Author: Zwaar Contrast
 *
 * Contact: postduif@zwaarcontrast.nl
 * 
 */
(function($, window, document, undefined) {
	"use strict";

	/*
	 * 	In the constructor we wrap the element on which the plugin is called on in a jQuey object 
	 *	and expose the passed on options for usage in the init function
	 */
	var Loader = function(elem, options) {
		this.el = elem;
		this.element = $(elem);
		this.options = options;
	};

	Loader.prototype = {

		/*
		 *	Default values, which can be overwritten by merging with config on initialisation
		 */
		defaults:{
			animationIDs : ['logo-color-one','logo-color-two','logo-color-three'],
			opacityLevel : 0.5,
			visibilityTimeout : 500
		},

		/*
		 *	Initialisation funtion, read passed config and call necessary functions to launch our plugin like binding events and setting status variables
		 */
		init: function() {
			var _self = this;

			//Get the options and merge with defaults
			this.config = $.extend({}, this.defaults, this.options);

			this.currentID = 0;
			this.isLoading = false;
			this.isReadyForAnimation = false;
			this.preparingForAnimation = false;
			this.isAnimating = false;
			this.visibilityTimeout = false;

			//Call functions for initialisation
			this.bindRequestKeyframes();
			this.bindEvents();

			return this;
		},
		doAnimation: function(){
			if(this.isLoading && !this.isAnimating && this.isReadyForAnimation){
				this.animate(this.config.animationIDs[this.currentID]);
				if(this.config.animationIDs.length > this.currentID + 1){
					this.currentID++;
				}else{
					this.currentID = 0;
				}
			}

			if(!this.isReadyForAnimation && !this.preparingForAnimation && this.isLoading){
				this.preparingForAnimation = true;
				this.prepareForAnimation();
			}

			if(this.isReadyForAnimation && !this.isLoading){
				this.notLoading();
			}
		},
		animate: function(id){
			var _self = this;
			_self.isAnimating = true;
			TweenLite.to("#"+id, .3, {opacity:1, delay:0, ease:Power4.easeInOut, onComplete:function(){
				TweenLite.to("#"+id, .3, {opacity:_self.config.opacityLevel, delay:0.3, ease:Power4.easeInOut, onComplete:function(){
						_self.isAnimating = false;
					}
				});
			}});
		},
		prepareForAnimation: function(){
			var _self = this;
			_self.preparingForAnimation = false;
			_self.isReadyForAnimation = true;
		},
		notLoading: function(){
			var _self = this;
			_self.isReadyForAnimation = false;
			TweenLite.to("#"+_self.config.animationIDs.join(',#'), .3, {opacity:_self.config.opacityLevel, delay:0, ease:Power4.easeInOut, onComplete:function(){
				_self.preparingForAnimation = false;
			}});
		},
		bindEvents: function(){
			var _self = this;
			$('body').off('setLoadingState').on('setLoadingState',function(){
				_self.isLoading = true;
				_self.visibilityTimeout = setTimeout(function(){
					_self.element.addClass('is-loading');
				},_self.config.visibilityTimeout);
			});

			$('body').off('disableLoadingState').on('disableLoadingState',function(){
				_self.isLoading = false;
				clearTimeout(_self.visibilityTimeout);
				_self.element.removeClass('is-loading');
			});

		},
		bindRequestKeyframes:function(){
			var _self = this;
			//Loop for Animation of the handler
			window.requestAnimFrame = (function(){
				return  window.requestAnimationFrame       ||
						window.webkitRequestAnimationFrame ||
						window.mozRequestAnimationFrame    ||
						window.oRequestAnimationFrame      ||
						window.msRequestAnimationFrame     ||
						function( callback ){
							window.setTimeout(callback, 1000 / 60);
						};
			})();

			(function animloop(){
				window.requestAnimFrame(animloop);
				if(!_self.isAnimating && !_self.preparingForAnimation){
					_self.doAnimation();
				}
			})();
		}
	};

	//Extend Jquery with the Loader function/object
	$.fn.Loader = function(options) {
		//Do for each of the passed elements
		return this.each(function() {
			//Construct new Loader object and call initialisation function
			new Loader(this, options).init();
		});
	};
})(jQuery, window, document);